import React, {useState, useEffect} from 'react';
import {View, TextInput} from 'react-native';

import sy from '~/styles';

import {Pressable, Camera} from '~/components/controls';

import SendIcon from '~/images/md-icons/send/materialicons/24px.svg';

const LINE_HEIGHT = 24;

export default (props) => {
  const {style, onChange, onSend, onImage} = props;
  const message = props.message ?? '';

  const [lines, setLines] = useState(1);

  useEffect(() => {
    if (message.length === 0) {
      setLines(1);
    }
  }, [message]);

  return (
    <View style={[sy['p-4'], sy['flex-row'], style]}>
      <View style={[sy['flex-1'], {display: 'block'}]}>
        <View
          style={[
            sy['flex-1'],
            sy['p-2'],
            {
              borderRadius: 10,
              backgroundColor: '#EBEBEB',
              height: lines * LINE_HEIGHT,
              boxSizing: 'content-box',
            },
          ]}>
          <TextInput
            style={[
              sy.regular,
              sy['flex-1'],
              {
                color: message.length > 0 ? '#4A4A49' : '#828282',
              },
            ]}
            multiline
            placeholder={'Typ een nieuw bericht'}
            value={message}
            onChangeText={(message) => onChange(message)}
            onContentSizeChange={({nativeEvent}) => {
              const {height} = nativeEvent.contentSize;
              setLines(Math.ceil(height / LINE_HEIGHT));
            }}
          />
        </View>
      </View>
      <View
        style={[
          {
            height: 30,
            paddingLeft: message.length || onImage ? 8 : 0,
            maxWidth: 100,
          },
          sy['pb-3'],
          sy['justify-center'],
          sy['overflow-hidden'],
          sy['self-end'],
        ]}>
        {message?.length > 0 ? (
          <Pressable
            onPress={() => {
              onSend();
              setLines(1);
            }}>
            <SendIcon fill="#231fda" />
          </Pressable>
        ) : onImage ? (
          <Camera
            onPhotoTaken={async (image) => {
              onImage(image);
            }}
          />
        ) : null}
      </View>
    </View>
  );
};
